export default {
  term: {
    order: -1,
    format: value => `Term '${value}'`
  },
  category: {
    isMultiple: true,
    delimiter: '/',
    order: 0
  },
  files_included: {
    isMultiple: true,
    delimiter: ',',
    labels: {
      '.sketchplugin': '.sketchplugin',
      adjustmentpresets: 'AdjustmentPresets',
      'affinity designer': 'Affinity Designer',
      'ai illustrator': 'AI Illustrator',
      'coreldraw cdr': 'CorelDRAW CDR',
      'epub file': 'ePub File',
      'flat png': 'Flat PNG',
      font: 'Font',
      'google slides pptx': 'Google Slides PPTX',
      'high dynamic range hdr': 'High Dynamic Range HDR',
      'indesign indd': 'InDesign INDD',
      'quark qxp': 'Quark QXP',
      'jpg image': 'JPG Image',
      'keynote key': 'Keynote KEY',
      'layered png': 'Layered PNG',
      'layered psd': 'Layered PSD',
      lrplugin: 'LRPlugin',
      lrtemplate: 'LRTemplate',
      'opentype otf': 'OpenType OTF',
      'openexr image': 'OpenEXR Image',
      other: 'Other',
      pfm: 'PFM',
      'photoshop abr': 'Photoshop ABR',
      'photoshop grd': 'Photoshop GRD',
      'photoshop asl': 'Photoshop ASL',
      'photoshop atn': 'Photoshop ATN',
      'photoshop csh': 'Photoshop CSH',
      'photoshop hdr': 'Photoshop HDR',
      'photoshop jsx': 'Photoshop JSX',
      'photoshop pat': 'Photoshop PAT',
      'photoshop psd': 'Photoshop PSD',
      'powerpoint ppt': 'Powerpoint PPT',
      'powerpoint pptx': 'Powerpoint PPTX',
      'sketch file': 'Sketch File',
      'tga image': 'TGA Image',
      'theme thmx': 'Theme THMX',
      'tiff image': 'TIFF Image',
      'transparent png': 'Transparent PNG',
      'truetype ttf': 'TrueType TTF',
      'vector eps': 'Vector EPS',
      'zxp file': 'ZXP file',
      'n/a': 'Not available'
    },
    order: 1
  },
  tags: {
    isMultiple: true,
    delimiter: ',',
    order: 2
  },
  price_min: {
    inRangeWith: { max: 'price_max' },
    label: 'At least',
    format: value => `$${value}`,
    order: 3
  },
  price_max: {
    inRangeWith: { min: 'price_min' },
    label: 'At most',
    format: value => `$${value}`,
    order: 4
  },
  length_min: {
    inRangeWith: { max: 'length_max' },
    label: 'At least'
  },
  length_max: {
    inRangeWith: { min: 'length_min' },
    label: 'At most'
  },
  sales: {
    isMultiple: true,
    delimiter: ',',
    labels: {
      'rank-0': 'No sales',
      'rank-1': 'Low',
      'rank-2': 'Medium',
      'rank-3': 'High',
      'rank-4': 'Top Sellers'
    },
    order: 5
  },
  rating_min: {
    isMultiple: false,
    labels: {
      '': 'Show All',
      '1': '1 star and higher',
      '2': '2 stars and higher',
      '3': '3 stars and higher',
      '4': '4 stars and higher'
    },
    order: 6
  },
  sort_by: {
    isMultiple: false,
    labels: {
      relevance: 'Best match',
      trending: 'Trending items',
      sales: 'Best sellers',
      rating: 'Best rated',
      date: 'Newest items',
      'price-asc': 'Price: low to high',
      'price-desc': 'Price: high to low'
    },
    order: 7
  },
  date: {
    isMultiple: false,
    labels: {
      '': 'Any date',
      'this-year': 'In the last year',
      'this-month': 'In the last month',
      'this-week': 'In the last week',
      'this-day': 'In the last day'
    },
    order: 8
  },
  platform: {
    isMultiple: false,
    delimiter: ' ',
    order: 9
  },
  compatible_with: {
    isMultiple: true,
    delimiter: ',',
    order: 10
  },
  attribute_value: {
    isMultiple: false,
    order: 11
  },
  poly_count: {
    isMultiple: false,
    order: 12,
    format: label => `${label} polygons`
  },
  file_formats: {
    isMultiple: true,
    isArrayFormat: true,
    delimiter: ',',
    order: 13,
    labels: {
      obj: '.obj (multi format)',
      fbx: '.fbx (multi format)',
      max: '.max (3ds Max)',
      c4d: '.c4d (cinema 4d)',
      ma: '.ma (maya)',
      blend: '.blend (blender)',
      '3ds': '.3ds (multi format)',
      mb: '.mb (maya)',
      lwo: '.lwo (lightwave)',
      dxf: '.dxf (multi format)',
      dwg: '.dwg (AutoCAD)',
      lws: '.lws (lightwave)',
      '3b': '.3b (3dcoat)',
      unitypackage: '.unitypackage (Unity3D)',
      vob: '.vob (Vue)',
      vue: '.vue (Vue)',
      ztl: '.ztl (zbrush)',
      xsi: '.xsi (softimage)',
      e3d: '.e3d (Instant3D)',
      lxo: '.lxo (Luxology modo)',
      hrc: '.hrc (softImage)'
    }
  },
  orientation: {
    isMultiple: false,
    labels: {
      '': 'Show All',
      landscape: 'Landscape',
      portrait: 'Portrait',
      square: 'Square'
    },
    order: 14
  },
  colors: {
    isMultiple: true,
    delimiter: ',',
    order: 15
  },
  sizes: {
    isMultiple: true,
    delimiter: ',',
    labels: {
      m: 'Medium',
      l: 'Large',
      xl: 'Extra large',
      xxl: 'Extra extra large'
    },
    order: 16
  },
  vocals_in_audio: {
    isMultiple: true,
    delimiter: ',',
    labels: {
      'background vocals/harmonies': 'Background Vocals',
      'instrumental version included': 'Instrumental Included'
    }
  },
  tempo: {
    isMultiple: false,
    labels: {
      'very-slow': 'Very slow (0 - 60 BPM)',
      slow: 'Slow (60 - 90 BPM)',
      medium: 'Medium (90 - 110 BPM)',
      upbeat: 'Upbeat (110 - 140 BPM)',
      fast: 'Fast (140 - 160 BPM)',
      'very-fast': 'Very fast (160+ BPM)'
    }
  },
  resolution_min: {
    isMultiple: false,
    labels: {
      '': 'Show all',
      '720p': '720p (HD)',
      '1080p': '1080p (Full HD)',
      '2K': '2K',
      '4K': '4K (UHD)'
    }
  },
  frame_rate: {
    isMultiple: false,
    shouldSort: true,
    labels: {
      '': 'Show All',
      '23.98': '23.98 fps',
      '24': '24 fps',
      '25': '25 fps',
      '29.97': '29.97 fps',
      '30': '30 fps',
      '50': '50 fps',
      '59.94': '59.94 fps',
      '60': '60 fps'
    }
  },
  requires_plugins: {
    isMultiple: false,
    format: value => `Requires Plugins: ${value}`,
    labels: {
      '': 'Show All',
      F: 'No',
      T: 'Yes'
    }
  },
  alpha: {
    isMultiple: false,
    isBoolean: true,
    labels: {
      1: 'Alpha channel'
    }
  },
  looped: {
    isMultiple: false,
    isBoolean: true,
    labels: {
      1: 'Looped'
    }
  },
  include_pro_affiliated: {
    labels: {
      true: 'Yes',
      false: 'No'
    }
  }
}
